import Dephne1 from "../../media/dephne/dephne (1).webp";
import Dephne2 from "../../media/dephne/dephne (2).webp";
import Dephne3 from "../../media/dephne/dephne (3).webp";
import Dephne4 from "../../media/dephne/dephne (4).webp";
import Dephne5 from "../../media/dephne/dephne (5).webp";
import Dephne6 from "../../media/dephne/dephne (6).webp";

const dephneimages = [Dephne1, Dephne2, Dephne3, Dephne4, Dephne5, Dephne6];

export default dephneimages;
